/* eslint-disable prettier/prettier */
import { v4 as uuidV4 } from "uuid";

export const QUERY = {
  allEngineers: `
  query MyQuery {
    allEngineers(condition:{isActive: true}){
       nodes{
        id
        value:id
        label:firstName
        firstName
        lastName
        emailId
        isActive
        createdAt
        updatedBy
      }
    }
  }
    `,
  allUser: (roleId = 6) => `
    query MyQuery {
        allUserProfiles(condition: {roleId: ${roleId}, isActive:true}) {
          nodes {
            id
            value:id
            label:firstName
            name:firstName
            last_name:lastName
            email_id:emailId
            emailId
            firstName
            lastName
            img:profilePic
            designation: masterRoleByRoleId{
              roleName
            }
          }
        }
      }
    `,
  addAccountant: ({ firstName, lastName, emailId }) => `
  mutation{
    createEngineer(input:{
      engineer:{
        id:"${uuidV4()}",
        firstName:"${firstName}",
        lastName:"${lastName}",
        emailId:"${emailId}",
        isActive:true,
        createdAt: "${new Date().toISOString()}"
        updatedAt: "${new Date().toISOString()}"
      }
    }){
      clientMutationId
    }
  }
    `,
  updateAccountant: ({ id, isActive = true, firstName, lastName }) => `
  mutation MyQuery {
    updateUserProfileById(
      input: { userProfilePatch: { firstName: "${firstName}", lastName: "${lastName}", isActive: ${isActive} }, id: "${id}" }
    ) {
      clientMutationId
    }
  }`
};